import { render } from "./BlogImplantsLoseTeeth.vue?vue&type=template&id=ede827c6"
import script from "./BlogImplantsLoseTeeth.vue?vue&type=script&lang=js"
export * from "./BlogImplantsLoseTeeth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__